export const USERS_PATH = '/users';
export const USERS_ADD_PATH = '/users/add';
export const USERS_EDIT_PATH = '/users/:userId/edit';

export const USER_PROFILE_PATH = '/user/profile';
export const USER_NOTIFICATIONS_PATH = '/user/notifications';
export const USER_PASSWORD_PATH = '/user/password';
